<template>
  <v-row v-if="!ptSrNo"
    class="patient-detail-controls escalon-bb elevation-0 align-center secondary"
    style="margin-right: 0px; margin-left: 0px;">
    <v-toolbar-title style="margin-left: 12px;" class="patient-name">SELECT A PATIENT</v-toolbar-title>
  </v-row>
  <v-row v-else
    class="patient-detail-controls escalon-bb elevation-0 secondary" 
    style="margin-right: 0px; margin-left: 0px;">
    <v-layout ref="patientData" class="patientData" column>
      <v-flex @mouseover="handleMouseover" @mouseout="handleMouseout">
        <v-toolbar-title class="patient-name">{{patient.firstName}} {{patient.lastName}}</v-toolbar-title>
      </v-flex>
      <v-flex class="patient-data">
        {{patient.ptId}}&nbsp;&nbsp;&nbsp;{{patient.gender}}&nbsp;&nbsp;&nbsp; {{ patient.dob }}
      </v-flex>
    </v-layout>
    <v-spacer id="tooltip"/>
    <v-tooltip v-model="tooltipIsVisible"
      attach="#tooltip"
      :position-x="tooltipXPos"
      right>
      <span class="ptSrNoTooltip">
        <span>Patient #{{htmlContainer[0]}}</span>
      </span>
    </v-tooltip>
    <v-layout
      v-if="exLnchEnabled"
      align-center
      justify-end
      shrink>
      <v-btn text
        @click="exlnch"
        class="toolbarButton">
        <v-avatar size="30" class="mr-1">
          <img src="../../assets/launch-icon.svg" />
        </v-avatar><span v-bind:class="{'hideLabelOnMobile': exLnchEnabled}">{{exLnchTitle}}</span>
      </v-btn>
    </v-layout>
    <v-layout
      align-center
      justify-end
      shrink>
      <v-btn text
        @click="$emit('editPatient')"
        class="toolbarButton"
        v-if="(!ssoEmrPro || enableSavingWithEmrPro) && !userIsViewOnly && !userIsReadOnly">
        <v-avatar size="30" class="mr-1">
          <img :src="require('../../assets/' + coloredAssetUrls.editPatient)" />
        </v-avatar><span v-bind:class="{'hideLabelOnMobile': exLnchEnabled}">Edit Patient</span>
      </v-btn>
    </v-layout>
    <v-layout
      align-center
      justify-end
      shrink>
      <v-btn text
        @click="$emit('manualUpload')"
        class="toolbarButton"
        v-if="(!ssoEmrPro || enableSavingWithEmrPro) && !userIsViewOnly">
        <v-avatar size="30" class="mr-1">
          <img :src="require('../../assets/' + coloredAssetUrls.manualUpload)" />
        </v-avatar><span v-bind:class="{'hideLabelOnMobile': exLnchEnabled}">Manual Upload</span>
      </v-btn>
    </v-layout>
    <v-layout
      align-center
      justify-end
      shrink>
      <v-btn text
        @click="openMultiview" 
        class="toolbarButton">
        <v-avatar size="30" class="mr-1">
          <img :src="require('../../assets/' + coloredAssetUrls.multiview)" />
        </v-avatar><span v-bind:class="{'hideLabelOnMobile': exLnchEnabled}">Multiview</span>
      </v-btn>
    </v-layout>
    <v-layout
      align-center
      justify-end
      shrink>
      <v-btn text 
        @click="openProofsheetFromExamList" 
        class="toolbarButton">
        <v-avatar size="30" class="mr-1">
          <img :src="require('../../assets/' + coloredAssetUrls.proofsheet)" />
        </v-avatar><span v-bind:class="{'hideLabelOnMobile': exLnchEnabled}">Proofsheet</span>
      </v-btn>
    </v-layout>
  </v-row>
</template>

<script>
import tooltipGenerator from "../mixins/TooltipGenerator";
import { mapActions, mapGetters } from "vuex";
import { openPopup } from "../../helpers/popup";

export default {
  name: "PatientDetailToolbar",
  computed: {
    ...mapGetters(["ssoEmrPro", "patient", "ptSrNo", "exLnchEnabled", "exLnchTitle", "exLnchURL", "userIsViewOnly", "enableSavingWithEmrPro", "userIsReadOnly"]),
  },
  mixins: [tooltipGenerator],
  methods: {
    ...mapActions(["openProofsheetFromExamList", "openMultiview"]),
    handleMouseover() {
      this.displayNewTooltip(this.ptSrNo);
      this.setTooltipXPos(this.$refs.patientData.clientWidth);
    },
    handleMouseout() {
      this.hideTooltip();
    },
    exlnch(){
      let launchUrlString = this.exLnchURL;
      if(!launchUrlString.includes("AXISAPPLAUNCH:")){
        launchUrlString = launchUrlString.replace("[PATIENTID]", this.patient.ptId);
        launchUrlString = launchUrlString.replace("[PATIENTFIRSTNAME]", this.patient.firstName);
        launchUrlString = launchUrlString.replace("[PATIENTLASTNAME]", this.patient.lastName);
        launchUrlString = launchUrlString.replace("[PATIENTDOB]", this.patient.dob);
        openPopup(launchUrlString);
      }     
    }
  }
};
</script>

<style lang="scss">
.ptSrNoTooltip {
  position: relative;
  display: absolute;

  .tooltiptext {
    visibility: hidden;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 4px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
  }
  &:hover .tooltiptext {
    visibility: visible;
  }
}
</style>